export const getSumOfDigits = (num: string) => {
  return num.split("").reduce((sum, digit) => sum + parseInt(digit), 0);
};
